<template>
  <span
    class="asahi-typography"
    :class="classObject"
  >
    <slot></slot>
  </span>
</template>

<script>
import { defineComponent } from 'vue'
export default defineComponent({
  name: 'AsahiTypography',
  props: {
    type: {
      type: String,
      default: 'headline-big'
    },
    color: {
      type: String,
      default: 'primary'
    },
    addClass: {
      type: String,
      default: ''
    }
  },
  computed: {
    classObject () {
      const classObj = [this.type, this.color]
      if (this.addClass) {
        classObj.push(this.addClass)
      }
      return classObj.join(' ')
    }
  }
})
</script>

<style scoped lang='scss'>
.asahi-typography {
  position: relative;
  font-family: $font-family-base;
}

.headline-main {
  font-size: calc($font-size * 2);        /* 32px */
  font-weight: $font-weight-above-medium; /* 700 */
  @include media-breakpoint-up(xl) {
    font-size: calc($font-size * 2.8125);
  }
}

.headline-big {
  // font-size: calc(16px * 2.5); /* 40px @ base 16px */
  font-size: calc($font-size * 1.75); /* 28px */
  font-weight: $font-weight-above-medium; /* 700 */
  @include media-breakpoint-up(xl) {
    font-size: calc($font-size * 2.5); /* 40px */
  }
}
.headline-medium {
  font-size: calc($font-size * 1.5); /* 28px */ //this part of lower screen is still not used so can be modified as per requirement
  font-weight: $font-weight-above-medium; /* 700 */
  @include media-breakpoint-up(xl) {
    font-size: calc($font-size * 1.75); /* 28px */
  }
}

.headline-1-extrabold {
  font-size: calc($font-size * 2);
  font-weight: $font-weight-above-medium; /* 700 */
}

.headline-regular {
  font-size: calc($font-size * 1.5);
  font-weight: $font-weight-normal; /* 500 */
}

.headline-bold {
  font-size: calc($font-size * 1.5);
  font-weight: $font-weight-medium; /* 600 */
}

.headline-extra-bold {
  font-size: calc($font-size * 1.5);
  font-weight: $font-weight-above-medium; /* 700 */
}

.headline-2-regular {
  font-size: calc($font-size * 1);
  font-weight: $font-weight-regular; /* 400 */
}
.headline-2-bold {
  font-size: calc($font-size * 1);
  font-weight: $font-weight-medium; /* 600 */
}
.headline-2-extrabold {
  font-size: calc($font-size * 1);
  font-weight: $font-weight-above-medium; /* 700 */
}

.headline-2-high {
  font-size: calc($font-size * 1);
  font-weight: $font-weight-high; /* 800 */
}

.orange {
  color: $secondary-orange;
}

.gold {
  color: $primary-gold;
}

.title-1-regular {
  font-size: $font-size-xl;
  font-weight: $font-weight-regular; //400
}
.title-1-bold {
  font-size: $font-size-xl;
  font-weight: $font-weight-medium; //600
}
.title-1-extrabold {
  font-size: $font-size-xl;
  font-weight: $font-weight-above-medium; //700
}

.subtitle-light {
  font-size: calc($font-size * 1);/* 16px @ base 16px */
  font-weight: $font-weight-light; /* 300 */
}
.subtitle-regular {
  font-size: calc($font-size * 1);/* 16px @ base 16px */
  font-weight: $font-weight-regular; /* 400 */
}

.subtitle-bold {
  font-size: calc($font-size * 1); /* 16px @ base 16px */
  font-weight: $font-weight-medium; /* 600 */
}

.subtitle-extrabold {
  font-size: calc($font-size * 1); /* 16px @ base 16px */
  font-weight: $font-weight-above-medium; /* 700 */
}

.product-bold-description {
  font-size: $font-size-sm; /* 16px @ base 16px */
  font-weight: $font-weight-medium; /* 600 */
}

.subtitle-extrabold {
  font-size: calc($font-size * 1); /* 16px @ base 16px */
  font-weight: $font-weight-above-medium; /* 700 */
}

.subtitle-1-regular {
  font-size: calc($font-size * .75);
  font-weight: $font-weight-regular; /* 400 */
}

.subtitle-1-line-through{
  text-decoration: line-through;
  font-size: calc($font-size * .75);
  font-weight: $font-weight-regular; /* 400 */
}
.subtitle-1-bold {
  font-size: calc($font-size * .75);
  font-weight: $font-weight-medium; /* 600 */
}
.subtitle-1-extrabold {
  font-size: calc($font-size * .75);
  font-weight: $font-weight-above-medium; /* 700 */
}
.subtitle-1-high {
  font-size: calc($font-size * .75);
  font-weight: $font-weight-high; /* 800 */
}

.subtitle-2-high {
  font-size: calc($font-size * .875);
  font-weight: $font-weight-high; /* 800 */
}
.subtitle-2-extrabold {
  font-size: calc($font-size * .875);
  font-weight: $font-weight-above-medium; /* 700 */
}
.subtitle-2-bold {
  font-size: calc($font-size * .875);
  font-weight: $font-weight-medium; /* 600 */
}
.subtitle-2-regular {
  font-size: calc($font-size * .875);
  font-weight: $font-weight-regular; /* 400 */
}
.subtitle-2-light {
  font-size: calc($font-size * .875);
  font-weight: $font-weight-light; /* 300 */
}

.body-1-regular {
  font-size: calc($font-size * 1); /* 16px */
  font-weight: $font-weight-regular; /* 400 */
}
.body-1-bold {
  font-size: calc($font-size * 1); /* 16px */
  font-weight: $font-weight-medium; /* 600 */
}
.body-1-extrabold {
  font-size: calc($font-size * 1); /* 16px */
  font-weight: $font-weight-above-medium; /* 700 */
}
.body-2-regular {
  font-size: calc($font-size * .625);
  font-weight: $font-weight-regular; /* 400 */
}
.body-2-bold {
  font-size: calc($font-size * .625);
  font-weight: $font-weight-medium; /* 600 */
}
.article-lead {
  font-size: calc($font-size * .5);
}
.article {
  font-size: calc($font-size * .375);
}
.button {
  font-size: calc($font-size * .5);
}
.caption {
  font-size: calc($font-size * .375);
}
.overline {
  font-size: calc($font-size * .5);
}

.headline-small-alt{
  font-size: calc($font-size * 1.25);
  font-weight: $font-weight-medium; /* 600 */
}

</style>
